
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SidebarProvider } from "@/components/ui/sidebar";
import { useAuth } from '../../contexts/AuthContext';
import { useTenantView } from '../../contexts/TenantViewContext';
import { useActingAsAdmin } from '../../hooks/useActingAsAdmin';
import { AppSidebar } from './AppSidebar';
import BottomNavigation from './BottomNavigation';
import { useIsMobile } from '../../hooks/use-mobile';
import { ConsentGuard } from '../ConsentGuard';
import AppContent from '../AppContent';
import ViewToggle from './ViewToggle';

const LayoutWithSidebar = () => {
  const { user } = useAuth();
  const { inTenantView } = useTenantView();
  const actingAsAdmin = useActingAsAdmin();
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  useEffect(() => {
    if (user) {
      const needsOnboarding = localStorage.getItem('onboarding_pending') === 'true';
      if (needsOnboarding && location.pathname !== '/onboarding') {
        navigate('/onboarding', { replace: true });
      }
    }
  }, [user, location.pathname, navigate]);

  // Don't show sidebar and bottom nav on auth pages
  const isAuthPage = ['/preauth', '/login', '/register', '/forgot-password', '/reset-password', '/accept-invitation', '/onboarding'].includes(location.pathname);
  
  if (isAuthPage) {
    return <AppContent />;
  }

  return (
    <ConsentGuard>
      <SidebarProvider>
        <div className="min-h-screen flex w-full">
          {user && <AppSidebar />}
          <main className="flex-1">
            <AppContent />
          </main>
        </div>
        {user && !actingAsAdmin && isMobile && <BottomNavigation />}
        {user && <ViewToggle />}
      </SidebarProvider>
    </ConsentGuard>
  );
};

export default LayoutWithSidebar;
